<template>
<div class="bb-image"
     @click.stop="clickToImage"
     @mouseenter="setDisplayPopup($event, true)"
     @mouseleave="setDisplayPopup($event, false)"
>
  <img v-if="image"
       :src="pathImg"
       class="bb-image__avatar"
  />
  <i v-else class="icon-user bb-image__avatar bb-image__avatar_icon"/>
  <transition name="bounce">
    <div v-if="getUserName && hoverImage"
         :style="popupPosition"
         class="bb-image-popup"
    >
      {{getUserName}}
    </div>
  </transition>
</div>
</template>

<script>
import {get} from 'lodash'
import UploadFileApi from '@/api/UploadFile/api'
export default {
  name: 'BBImage',
  props: ['user', 'username'],
  data () {
    return {
      pathImg: '',
      imageId: '',
      hoverImage: false,
      popupPosition: {}
    }
  },
  computed: {
    getUserName () {
      return get(this.user, 'username', '')
    },
    image () {
      return get(this.user, 'image', '')
    }
  },
  methods: {
    checkImage () {
      if (typeof this.image === 'string') {
        this.imageId = this.image
        this.getPath(this.imageId)
        return
      }
      const path = get(this.image, 'path', '')
      if (path) {
        this.pathImg = path
      } else {
        const idImageOne = get(this.image, 'id', '')
        const idImageTwo = get(this.image, '_id', idImageOne)
        this.imageId = idImageTwo
        this.getPath(this.imageId)
      }
    },
    clickToImage () {
      const id = get(this.user, 'id', '')
      this.$emit('filterByImage', id)
    },
    getPath (id) {
      if (!id) {
        return
      }
      UploadFileApi.getFile(id)
        .then((resp) => {
          this.pathImg = get(resp, ['data', 'path'], '')
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setDisplayPopup (e, val) {
      this.hoverImage = val
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.popupPosition = {
          position: 'fixed',
          top: position.top + position.height + 4 + 'px',
          left: 'auto'
        }
      } else {
        this.popupPosition = {}
      }
    }
  },
  beforeMount () {
    this.checkImage()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bb-image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &__avatar {
    width: 29px;
    height: 29px;
    border-radius: 50%;

    &_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      color: $color-accent;
    }
  }

  &-popup {
    position: absolute;
    left: auto;
    top: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    padding: 4px 7px;
    background: rgba($color-black, 0.55);
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    color: $color-white;
    border-radius: 3px;
    z-index: 20;
    pointer-events: none;
    text-transform: capitalize;

    &:before {
      content: '';
      position: absolute;
      left: auto;
      top: -3px;
      display: block;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-bottom: 3px solid rgba($color-black, 0.55);;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBImage/BBImage.vue